/**
 * Created by neno on 12.05.16.
 */
import Relay from 'react-relay'
import PersonDetailBio from './Bio'

const PersonDetailBioContainer = Relay.createContainer(PersonDetailBio, {
    fragments: {
        person: () => Relay.QL`
            fragment on Person {
                PerMarkdown,
            }
        `,
    },
});


export default PersonDetailBioContainer;


// WEBPACK FOOTER //
// ./app/components/Person/Detail/Bio/index.js